module.exports = __webpack_public_path__ + "static/media/pearl-banner.930ff6f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DrumsPage/assets/pearl-banner.png
// module id = 395
// module chunks = 0